export class VmsCreditMemoLineModel { 
        NatureOfExpense:any='';
        Quantity:any=0;
        DUC:any='';
        GstGroupCode:any='';
        HSNSAC:any=''; 
        GstBaseAmt:any;
        LineNo:any;
        TotalGstAmt:any;
}
